export enum TabKeys {
    AllProjects,
    MyProjects,
}
